<template>
    <v-container fluid class="ma-0 pa-0">
        <v-layout
        text-center
        wrap
        >
        <v-flex solo>   
            <v-toolbar
            dense
            flat
            class="ma-0 pa-0"
            >
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" icon
                        class="pl-2 mr-4"
                        :disabled="loading"
                        v-bind="attrs"
                        v-on="on">
                            <v-icon>mdi-plus</v-icon>
                            Add
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click.stop="showCaseDialog()">
                            <v-icon>mdi-briefcase</v-icon>
                            <v-list-item-title>Create New Case</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click.stop="showDialog()">
                            <v-icon>mdi-file-multiple</v-icon>
                            <v-list-item-title>Add New Single Item</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-divider
                vertical
                ></v-divider>

                <v-spacer></v-spacer>

                <v-btn icon
                :disabled="loading"
                @click.stop="Refresh()">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider></v-divider>

            <v-container v-if="activeTab=='Cases'">
                <CaseList
                pageTitle="My Cases"
                :uid="this.$route.params.userDb.uid"
                :orgid="this.$route.params.userDb.orgid"
                :favourites="this.$route.params.userDb.faveCases"
                currentCollectionSelected="Personal"></CaseList>
            </v-container>

            <v-container v-if="activeTab=='Treatments'">
                <TreatmentList
                pageTitle="My Treatments"
                :uid="this.$route.params.userDb.uid"
                :orgid="this.$route.params.userDb.orgid"
                :favourites="this.$route.params.userDb.faveTreatments"
                currentCollectionSelected="Personal"></TreatmentList>
            </v-container>   

            <v-dialog v-model="addTreatmentDialog" persistent max-width="800px">
                <AddTreatmentPopup
                v-on:dialogClosed="addTreatmentDialog=false"
                label="Add New Treatment"
                :editMode="false"
                :originalTreatment="null"></AddTreatmentPopup>
            </v-dialog>

            <v-dialog v-model="addCaseDialog" persistent max-width="800px">
                <AddCasePopup
                v-on:dialogClosed="addCaseDialog=false"
                label="Add New Case"
                :editMode="false"
                :originalCase="null"></AddCasePopup>
            </v-dialog>
                        
        </v-flex>
        </v-layout>

        <v-bottom-navigation
        v-model="activeTab"
        color="primary"
        grow
        fixed
        shift
        >
        <v-btn value="Cases">
            <span>Cases</span>
            <v-icon>mdi-briefcase</v-icon>
            <!-- <v-icon>mdi-book-multiple</v-icon> -->
        </v-btn>
    
        <v-btn value="Treatments">
            <span>Treatments</span>
            <v-icon>mdi-file-multiple</v-icon>
        </v-btn>    
        </v-bottom-navigation>
    </v-container>
    
</template>

<script>
import AddTreatmentPopup from './../../components/Treatments/Popups/AddTreatmentPopup.vue'
import AddCasePopup from './../../components/Cases/Popups/AddCasePopup.vue'
import TreatmentList from './../../components/Treatments/TreatmentList/TreatmentList.vue'
import CaseList from './../../components/Cases/CaseList/CaseList.vue'
import TreatmentDataService from './../../services/treatmentDataService.js'

export default {
    name: 'myTreatmentsPage',
    components: {
        AddTreatmentPopup,
        AddCasePopup,
        TreatmentList,
        CaseList
    },
    computed: {
    },
    created() {
        this.load();      
    },
    methods: {
        async load(){
            //First initialise the data service
            this.treatmentService = new TreatmentDataService(this.$route.params.userDb);
        },
        showDialog(){
            this.addTreatmentDialog = true;
        },
        showCaseDialog(){
            this.addCaseDialog = true;
        },
        Refresh(){
            //Placeholder to refresh current list (It would have to prop into the Lists)
        }
    },
    props: {
    },
    data: () => ({
        caseItems: [],
        loading: false,
        addTreatmentDialog: false,
        addCaseDialog: false,
        treatmentService: null,
        activeTab: "Cases"
    })
}
</script>
